var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre_input',{attrs:{"value":_vm.value,"label":_vm.label,"md":_vm.md,"tag":_vm.c_tag,"view_only":_vm.view_only}},[_c('in-calendar',{attrs:{"date":_vm.model,"placeholder_label":_vm.label},on:{"update:date":function($event){_vm.model=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }